import React, { useEffect, useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'Valentina',
  city: 'Buenos Aires'
}, {
  name: 'Gonzalo',
  city: 'Córdoba'
}, {
  name: 'Luciana',
  city: 'Rosario'
}, {
  name: 'Facundo',
  city: 'Mendoza'
}, {
  name: 'Carolina',
  city: 'La Plata'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay
    const initialTimeout = setTimeout(() => setIsVisible(true), 3000);
    // Rotate every 7 seconds
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        if (!isDismissed) setIsVisible(true);
      }, 500); // Wait for fade out before changing data
    }, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  const current = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-279">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-w-xs flex items-start space-x-3 relative" data-id="element-280">
        <button onClick={() => setIsDismissed(true)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-281">
          <X className="w-4 h-4" data-id="element-282" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-283">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-284" />
        </div>

        <div data-id="element-285">
          <p className="text-sm font-bold text-gray-900" data-id="element-286">{current.name}</p>
          <p className="text-xs text-gray-600" data-id="element-287">de {current.city}</p>
          <p className="text-xs text-green-600 font-medium mt-1" data-id="element-288">
            Compró Airfryer Pack Definitivo
          </p>
          <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-289">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}